import { Outlet, useOutletContext } from "react-router-dom";
import { Project } from "../../../../types/entitys/project";

export const Needs = () => {
    const project = useOutletContext<Project>();

    return (
        <Outlet context={project} />
    )
}
